export default function BrandStory() {
  return (
    <section id="hikaye" className="bg-accent-50 py-16 md:py-24 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left: photo */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden aspect-[4/3] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20home%20kitchen%20scene%20with%20hands%20kneading%20dough%20and%20fresh%20ingredients%20on%20wooden%20counter%2C%20copper%20pots%2C%20soft%20natural%20window%20light%2C%20steam%20rising%20from%20pots%2C%20authentic%20Turkish%20home%20cooking%20heritage%2C%20editorial%20photography%2C%20warm%20cream%20tones%2C%20heartfelt%20and%20nostalgic&width=900&height=680&seq=story-mutfak&orientation=landscape"
                alt="Meliha Sultan mutfak hikayesi"
                title="Meliha Sultan mutfak hikayesi"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right: text */}
          <div>
            <span className="text-xs font-bold tracking-[0.25em] text-primary-600 uppercase">
              Meliha Sultan Hikayesi
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              YILLARIN MUTFAK TECRÜBESİ,
              <br />
              BUGÜN SENİN SOFRANDA.
            </h2>
            <p className="mt-6 text-foreground-600 leading-relaxed">
              Meliha Sultan adı bir marka isminden fazlasıdır; ev mutfağının
              tarif mirasını, özeni ve yılların deneyimini temsil eder.
              Yaklaşık 30 yıllık mutfak tecrübesiyle hazırlanan her öğünde,
              anne elinin sıcaklığı yaşatılır.
            </p>
            <p className="mt-4 text-foreground-600 leading-relaxed">
              Teknoloji yalnızca sipariş yöntemini değiştirdi. Mutfaktaki özen
              hiç değişmedi.
            </p>
            <a
              href="#hikaye"
              className="mt-7 inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-bold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              HİKÂYEMİZİ KEŞFET
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}